var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('Payment',{staticClass:"marginal",attrs:{"value":1}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }